










































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class PostCard extends Vue {
  @Prop({ type: Object, required: true }) post!: any;
  @Prop({ type: String, required: true }) imageUrl!: string;
  @Prop({ type: Number, default: 160 }) excerptLength!: number;
  @Prop({ type: Boolean, default: true }) showCta!: boolean;
  @Prop({ type: String, default: "" }) ctaLabel!: string;

  get postLink() {
    return `/post/${this.post.id}`;
  }

  get excerpt() {
    if (!this.excerptLength || this.excerptLength <= 0) return "";
    const shortText =
      (this.post && this.post.smalText) ||
      (this.post && this.post.smallText) ||
      (this.post && this.post.shortText) ||
      (this.post && this.post.shortDescription) ||
      "";
    const raw =
      shortText ||
      (this.post && this.post.text) ||
      (this.post && this.post.description) ||
      (this.post && this.post.summary) ||
      "";
    if (!raw) return "";
    const tmp = document.createElement("div");
    tmp.innerHTML = raw;
    const text = (tmp.textContent || tmp.innerText || "").trim();
    if (!text) return "";
    if (shortText) return text;
    if (text.length <= this.excerptLength) return text;
    return `${text.slice(0, Math.max(0, this.excerptLength - 3))}...`;
  }

  get ctaText() {
    return (this.ctaLabel || this.$t("Read more")).toString();
  }

}
